/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("确定");
const _hoisted_2 = {
  class: "flex"
};
const _hoisted_3 = {
  class: "flex"
};
import { apiSendSms, apiSetEmail } from '@/api/user';
import { useGetVerCode } from '@ultra/share/hooks/useGetVercode';
export default /*#__PURE__*/_defineComponent({
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['success'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const editEmailForm = ref({
      old_email_code: '',
      email: '',
      email_code: ''
    });
    const ruleFormEmailRef = ref();
    const editEmailRules = reactive({
      old_email_code: {
        required: true,
        message: '请输入验证码',
        trigger: 'blur'
      },
      email: [{
        required: true,
        message: '请输入新邮箱地址',
        trigger: 'blur'
      }, {
        type: 'email',
        message: '请输入正确的邮箱地址'
      }],
      email_code: {
        required: true,
        message: '请输入验证码',
        trigger: 'blur'
      }
    });
    const getVerCode = async () => {
      const params = {
        Email: props.userInfo.Email,
        Type: 7
      };
      return await apiSendSms(params);
    };
    const {
      codeState,
      getVerCodeFn
    } = useGetVerCode(getVerCode);
    const emailTimer = ref();
    const emailCodeState = ref({
      isClick: true,
      time: 60,
      text: '获取验证码'
    });
    const getVerCodeNewEmail = async formEl => {
      if (!formEl) return;
      formEl.validateField('email', async valid => {
        if (valid) {
          let params = {};
          params.Email = editEmailForm.value.email;
          params.Type = 7;
          const res = await apiSendSms(params);
          if (res.code === 0) {
            emailCodeState.value.isClick = false;
            emailTimer.value = setInterval(() => {
              emailCodeState.value.text = emailCodeState.value.time + 's';
              if (emailCodeState.value.time <= 0) {
                clearInterval(emailTimer.value);
                emailCodeState.value.text = '重新获取';
                emailCodeState.value.isClick = true;
              }
              emailCodeState.value.time--;
            }, 1000);
          }
        }
      });
    };
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          apiSetEmail({
            ...editEmailForm.value
          }).then(res => {
            if (res.code === 0) {
              emits('success');
              ruleFormEmailRef.value.resetFields();
            }
          });
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createBlock(_component_u_card_pane, {
        name: "editEmail"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_Teleport, {
          to: "#editEmail"
        }, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => handleOk(ruleFormEmailRef.value))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        })])), _createVNode(_component_el_form, {
          ref_key: "ruleFormEmailRef",
          ref: ruleFormEmailRef,
          model: editEmailForm.value,
          rules: _unref(editEmailRules),
          "label-width": "120px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [__props.userInfo.Email ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "旧邮箱"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
              "model-value": __props.userInfo.Email,
              prop: "",
              disabled: "",
              style: {
                "width": "300px"
              }
            }, null, 8, ["model-value"]), _createVNode(_component_el_button, {
              class: "marginL20",
              type: "primary",
              loading: _unref(codeState).isLoading,
              disabled: !_unref(codeState).isClick,
              onClick: _unref(getVerCodeFn)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(codeState).text), 1)]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"])])]),
            _: 1
          })) : _createCommentVNode("", true), __props.userInfo.Email ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "旧邮箱验证码",
            prop: "old_email_code"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editEmailForm.value.old_email_code,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => editEmailForm.value.old_email_code = $event),
              style: {
                "width": "300px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "新邮箱",
            prop: "email"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
              modelValue: editEmailForm.value.email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => editEmailForm.value.email = $event),
              style: {
                "width": "300px"
              }
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              class: "marginL20",
              type: "primary",
              disabled: !emailCodeState.value.isClick,
              onClick: _cache[3] || (_cache[3] = $event => getVerCodeNewEmail(ruleFormEmailRef.value))
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(emailCodeState.value.text), 1)]),
              _: 1
            }, 8, ["disabled"])])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新邮箱验证码",
            prop: "email_code"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editEmailForm.value.email_code,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => editEmailForm.value.email_code = $event),
              style: {
                "width": "300px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      });
    };
  }
});